import React from 'react';
import { competitors } from '../data/dashboardData';
export function CompetitorRates() {
  const min = 780;
  const range = 220;
  return <section aria-labelledby="competitor-title" className="border border-[#d8d2c6] bg-[#fffcf7] p-4 sm:p-5" data-id="element-1">
      <div className="flex items-start justify-between" data-id="element-2">
        <div data-id="element-3">
          <h2 id="competitor-title" className="font-serif text-xl text-[#0b2032]" data-id="element-4">
            Competitive rate set
          </h2>
          <p className="mt-1 text-xs text-[#73766f]" data-id="element-5">
            Deluxe King · 12 July · Flexible
          </p>
        </div>
        <span className="border border-[#d6d0c5] px-2 py-1 text-[10px] font-semibold text-[#5e686e]" data-id="element-6">
          4 hotels
        </span>
      </div>
      <div className="mt-5 space-y-4" data-id="element-7">
        {competitors.map(hotel => <div key={hotel.name} data-id="element-8">
            <div className="mb-1.5 flex items-center justify-between text-xs" data-id="element-9">
              <span className={hotel.own ? 'font-bold text-[#0b2032]' : 'text-[#53616a]'} data-id="element-10">
                {hotel.name}
              </span>
              <span data-id="element-11">
                <b className="text-[#0b2032]" data-id="element-12">€{hotel.rate}</b>{' '}
                <small className={hotel.own ? 'text-[#9a7b45]' : 'text-[#88857d]'} data-id="element-13">
                  {hotel.delta}
                </small>
              </span>
            </div>
            <div className="h-1.5 bg-[#e6e1d8]" data-id="element-14">
              <div className={`h-full ${hotel.own ? 'bg-[#b08b4e]' : 'bg-[#7e8b91]'}`} style={{
            width: `${Math.max(15, (hotel.rate - min) / range * 85 + 15)}%`
          }} data-id="element-15" />
            </div>
          </div>)}
      </div>
      <div className="mt-5 flex items-center justify-between border-t border-[#e4ded4] pt-3 text-[10px]" data-id="element-16">
        <span className="text-[#74766f]" data-id="element-17">
          Market median <strong className="text-[#0b2032]" data-id="element-18">€908</strong>
        </span>
        <span className="font-semibold text-[#9a7b45]" data-id="element-19">
          Positioned 2.0% below
        </span>
      </div>
    </section>;
}